module.exports = __webpack_public_path__ + "img/painter.0ba66151.jpg";